import React from 'react';
interface ReceiptHeaderProps {
  companyInfo: {
    name: string;
    logo: string;
    address: string;
    contact: string;
  };
  receiptNo: string;
  receiptDate: string;
  bookingRef: string;
  gstRegNo: string;
  tourCode: string;
  paymentMethod: string;
  collectedBy: string;
  printedBy: string;
}
export function ReceiptHeader({
  companyInfo,
  receiptNo,
  receiptDate,
  bookingRef,
  gstRegNo,
  tourCode,
  paymentMethod,
  collectedBy,
  printedBy
}: ReceiptHeaderProps) {
  return <div className="mb-8" data-id="element-1051">
      <div className="flex justify-between items-start mb-4" data-id="element-1052">
        {/* Left: Logo */}
        <div data-id="element-1053">
          <img src={companyInfo.logo} alt={companyInfo.name} className="h-14 object-contain object-left" data-id="element-1054" />
        </div>

        {/* Right: Company Address */}
        <div className="text-right" data-id="element-1055">
          <h1 className="text-sm text-neutral-900 mb-1" data-id="element-1056">{companyInfo.name}</h1>
          <div className="text-[10px] text-neutral-500 space-y-0.5 leading-relaxed whitespace-pre-line" data-id="element-1057">
            {companyInfo.address}
          </div>
          <div className="text-[10px] text-neutral-500 mt-1" data-id="element-1058">
            {companyInfo.contact}
          </div>
        </div>
      </div>

      {/* Centered Title */}
      <h2 className="text-lg font-bold text-neutral-900 mb-2 tracking-tight text-center" data-id="element-1059">
        OFFICIAL RECEIPT
      </h2>

      {/* Receipt Details Box */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3 mb-4" data-id="element-1060">
        {/* Two Column Grid - Reorganized */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-1.5" data-id="element-1061">
          {/* Left Column */}
          <div className="space-y-1.5" data-id="element-1062">
            <div className="flex justify-between" data-id="element-1063">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1064">
                Receipt No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-1065">
                {receiptNo}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-1066">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1067">
                Receipt Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1068">{receiptDate}</span>
            </div>
            <div className="flex justify-between" data-id="element-1069">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1070">
                Payment Method:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1071">{paymentMethod}</span>
            </div>
            <div className="flex justify-between" data-id="element-1072">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1073">
                GST Reg. No.:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1074">{gstRegNo}</span>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-1.5" data-id="element-1075">
            <div className="flex justify-between" data-id="element-1076">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1077">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1078">{bookingRef}</span>
            </div>
            <div className="flex justify-between" data-id="element-1079">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1080">
                Tour Code:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1081">{tourCode}</span>
            </div>
            <div className="flex justify-between" data-id="element-1082">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1083">
                Collected By:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-1084">
                {collectedBy}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-1085">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1086">
                Printed By:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1087">{printedBy}</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}